// extracted by mini-css-extract-plugin
export default {"inline":"BoothSetup_inline__SwqbB","label":"BoothSetup_label__zlVm-","value":"BoothSetup_value__qA-BQ","block":"BoothSetup_block__IHCgd"};